import React from "react";
import "./sass/index.scss";
import "./sass/bootstrap.scss";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
//import * as serviceWorker from "./serviceWorker";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import WebfontLoader from "@dr-kobros/react-webfont-loader";

// Pages
import Study from "./pages/Study/Study";
import Lessons from "./pages/Lessons/Lessons";
import Favorites from "./pages/Favorites/Favorites";
import Support from "./pages/Support/Support";
import InviteFriends from "./pages/InviteFriends/InviteFriends";
import Profile from "./pages/Profile/Profile";
import Lesson from "./pages/Lesson/Lesson";
import Subscription from "./pages/Subscription/Subscription";
import Auth from "./pages/Auth/Auth";
import AppProvider from "./AppProvider";

import PrivateRoute from "./PrivateRoute";
import setApiUrl from "./utils/setApiUrl";
import setAuthToken from "./utils/setAuthToken";
import Pronunciations from "./pages/Lessons/Pronunciation";
import Tips from "./pages/Lessons/Tips";

import { isMobileOnly } from "react-device-detect";
import Intermediate from "./pages/Lessons/Intermediate";
import Advanced from "./pages/Lessons/Advanced";
const WebFontConfig = {
	google: {
		families: ["Poppins:400,500,600,700,800"],
	},
};

const App = (props) => {
	setApiUrl();
	if (localStorage.token) {
		setAuthToken(localStorage.token);
	}
	return (
		<AppProvider>
			<WebfontLoader config={WebFontConfig}>
				<BrowserRouter>
					<Switch>
						<Route path="/auth" component={Auth} />
						<PrivateRoute path="/lessons" component={Lessons} />
						<PrivateRoute path="/invite-friends" component={InviteFriends} />
						<PrivateRoute path="/favorites" component={Favorites} />
						<PrivateRoute path="/lesson/:id/:category" component={Lesson} />
						<PrivateRoute path="/intermediate" component={Intermediate} />
						<PrivateRoute path="/advanced" component={Advanced} />
						<PrivateRoute path="/pronunciations" component={Pronunciations} />
						<PrivateRoute path="/tips" component={Tips} />
						<PrivateRoute path="/profile" component={Profile} />
						<PrivateRoute path="/subscription" component={Subscription} />
						<PrivateRoute path="/support" component={Support} />
						{isMobileOnly ? <PrivateRoute path="/" component={Study} /> : <Redirect from="/" to="/lessons" />}
						<Redirect from="*" to="/auth" />
					</Switch>
				</BrowserRouter>
			</WebfontLoader>
		</AppProvider>
	);
};

export default App;